import { gql } from "@apollo/client";

export default gql`
	mutation ($email: String!, $verificationCode: String!) {
		verification(email: $email, verificationCode: $verificationCode)
	}
`;
